export function authHeaderForContext(context) {
  if (context?.sessionAuth) return {};
  return context?.user ? { "X-User": context.user } : { "X-Role": context?.role || "finance_admin" };
}

export function buildQuery(params) {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params || {})) {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value));
    }
  }
  const value = query.toString();
  return value ? `?${value}` : "";
}

export function apiErrorMessage(status, payload = {}) {
  return payload.message || payload.error || `HTTP ${status}`;
}

export function shouldAttachJsonContentType(body) {
  if (!body) return false;
  if (typeof FormData !== "undefined" && body instanceof FormData) return false;
  return true;
}

export function downloadMetadata(path, filename, response, blob) {
  return {
    path,
    filename,
    contentType: response.headers?.get?.("Content-Type") || "",
    size: blob.size || 0
  };
}

export async function triggerBrowserDownload(path, filename, response, environment) {
  const blob = await response.blob();
  const url = environment.URL.createObjectURL(blob);
  const link = environment.document.createElement("a");
  link.href = url;
  link.download = filename;
  environment.document.body.append(link);
  link.click();
  link.remove();
  environment.URL.revokeObjectURL(url);
  return downloadMetadata(path, filename, response, blob);
}

export function uploadSummaryFromEntries(entries) {
  const files = [];
  const summary = {};
  for (const [key, value] of entries) {
    if (key === "file") {
      if (value?.name) files.push(value.name);
    } else {
      summary[key] = value;
    }
  }
  return { ...summary, files };
}

export function uploadPreflightItems(summary, templateLabel = (value) => value || "тип не указан") {
  const items = [
    {
      title: "Что проверит система",
      detail: "fingerprint эталона, обязательные листы, месяцы, итоги и доступность формы в кампании"
    },
    {
      title: "Файлы",
      detail: Array.isArray(summary?.files) && summary.files.length ? summary.files.join(", ") : "файл не выбран"
    },
    {
      title: "Шаблон",
      detail: templateLabel(String(summary?.template_type || ""))
    }
  ];
  if (summary?.upload_title) items.push({ title: "Название загрузки", detail: String(summary.upload_title) });
  if (summary?.upload_comment) items.push({ title: "Комментарий", detail: String(summary.upload_comment) });
  return items;
}

export function uploadQueueResultText(result = {}) {
  return `Поставлено в очередь: ${result.count || result.imports?.length || 1}`;
}

export function uploadSubmissionContract(formData) {
  return {
    endpoint: "/api/imports",
    method: "POST",
    attachJsonContentType: shouldAttachJsonContentType(formData),
    summary: uploadSummaryFromEntries(formData.entries()),
    invalidates: mutationInvalidationTargets("upload_import")
  };
}

const INVALIDATION_TARGETS = {
  upload_import: ["imports", "queue"],
  commit_import: ["import_detail", "imports", "requests", "tasks"],
  rollback_import: ["import_detail", "imports", "requests", "tasks"],
  queue_action: ["queue", "imports", "dashboard"],
  notification_read: ["notifications", "dashboard"],
  request_transition: ["requests", "approval_queue", "tasks"],
  budget_preview: ["budget_preview", "reports", "requests"],
  budget_selection: ["budget_preview", "audit"],
  dictionary_mutation: ["dictionaries"],
  validation_resolve: ["validation_center", "import_detail", "requests", "approval_queue", "tasks", "dashboard"],
  validation_ignore: ["validation_center", "import_detail", "reports"],
  validation_mapping: ["validation_center", "import_detail", "reports", "sheets"],
  bulk_validation_resolve: ["validation_center", "import_detail", "requests", "approval_queue", "tasks", "dashboard"],
  control_run: ["controls", "requests", "approval_queue", "tasks", "dashboard"],
  control_resolve: ["controls", "requests", "approval_queue", "tasks", "dashboard"],
  sheet_action: ["sheets", "reports", "validation_center", "requests", "approval_queue", "tasks"],
  request_sheet_action: ["sheets", "reports", "validation_center", "requests", "approval_queue", "tasks", "request_detail"],
  admin_reset_user_data: ["dictionaries", "dashboard", "requests", "imports", "queue", "reports", "validation_center", "audit"]
};

export function mutationInvalidationTargets(mutation) {
  return [...(INVALIDATION_TARGETS[mutation] || [])];
}

const TERMINAL_QUEUE_STATUSES = new Set(["done", "completed", "success", "failed", "error", "cancelled", "canceled"]);

export function isQueueJobActive(job = {}) {
  const status = String(job.status || "").toLowerCase();
  return !status || !TERMINAL_QUEUE_STATUSES.has(status);
}

export function hasActiveQueueJobs(jobs = []) {
  return Array.isArray(jobs) && jobs.some(isQueueJobActive);
}
